// src/store/features/message/messageTypes.js:
export const ADD_MESSAGE = "ADD_MESSAGE";
export const RECEIVE_MESSAGE = "RECEIVE_MESSAGE";
export const LOAD_MESSAGES = "LOAD_MESSAGES";
export const LOAD_MESSAGES_SUCCESS = "LOAD_MESSAGES_SUCCESS";
export const LOAD_MESSAGES_FAIL = "LOAD_MESSAGES_FAIL";
export const AUTH_SIGNOUT_SUCCESS = "AUTH_SIGNOUT_SUCCESS";
export const UPDATE_MESSAGE = "UPDATE_MESSAGE";
export const DELETE_MESSAGE = "DELETE_MESSAGE";
export const SET_SELECTED_CHAT = "SET_SELECTED_CHAT";
export const DELETE_CHAT = "DELETE_CHAT";
export const DELETE_ALL_CHATS = "DELETE_ALL_CHATS";
export const SET_IS_NEW_CHAT = "SET_IS_NEW_CHAT";
export const SET_IS_CHAT_FROM_RECENT_CHAT = "SET_IS_CHAT_FROM_RECENT_CHAT";
export const GENERATE_PDF = "GENERATE_PDF";
export const RESET_GENERATE_PDF = "RESET_GENERATE_PDF";
export const CLEAR_ALL_CHAT = "CLEAR_ALL_CHAT";


// TEXT LANGUAGE DETECTION STATES
export const IS_TEXT_LANGUAGE_DETECTING = "IS_TEXT_LANGUAGE_DETECTING";
export const TEXT_LANGUAGE_DETECTION_DATA = "TEXT_LANGUAGE_DETECTION_DATA";
export const TEXT_LANGUAGE_DETECTION_ERROR = "TEXT_LANGUAGE_DETECTION_ERROR";

// CONTENT GENERATION STATES
export const IS_CONTENT_GENERATING = "IS_CONTENT_GENERATING";
export const CONTENT_GENERATION_DATA = "CONTENT_GENERATION_DATA";
export const CONTENT_GENERATION_ERROR = "CONTENT_GENERATION_ERROR";

// NER DETECTION STATES
export const IS_NER_DETECTING = "IS_NER_DETECTING";
export const NER_DETECTION_DATA = "NER_DETECTION_DATA";
export const NER_DETECTION_ERROR = "NER_DETECTION_ERROR";